export default __webpack_public_path__ + "static/media/social_icon_ikara.63f8728d.jpg";